<template>
  <b-container class="container-fluid d-flex h-100 flex-column" style="margin-top:90px;">
    <b-row class="h-100">
      <b-col cols="10" offset="1" xl="4" offset-xl="4" class="align-self-center">
        <b-card class="shadow" header="Set your security questions">
          <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>{{ErrorText}}</b-alert>
          <b-form @submit="onSubmit">
            <b-form-group id="input-group-fsq" :label="$t('F_SQ')" label-for="fsq">
              <b-form-select id="fsq" v-model="firstQuestionSelection" :options="options"></b-form-select>
            </b-form-group>
            <b-form-group>
              <b-form-input
                v-model="firstAnswer"
                type="text"
                required
                :placeholder="$t('ENTER_ANSWER')"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-ssq" :label="$t('S_SQ')" label-for="ssq">
              <b-form-select id="ssq" v-model="secondQuestionSelection" :options="options"></b-form-select>
            </b-form-group>
            <b-form-group>
              <b-form-input
                v-model="secondAnswer"
                type="text"
                required
                :placeholder="$t('ENTER_ANSWER')"
              ></b-form-input>
            </b-form-group>

            <div class="d-flex align-items-center">
              <b-button type="submit" variant="primary">{{$t('APPLY')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { ajaxGet, ajaxPost } from "../ajax";
import {apiUrl} from "../main";

export default {
  props: ["token"],
  data: function() {
    return {
      firstQuestionSelection: null,
      secondQuestionSelection: null,
      firstAnswer: null,
      secondAnswer: null,
      options: [],
      showDismissibleAlert: false,
      ErrorText: ""
    };
  },
  mounted: function() {
    var ssq = this;

    setTimeout(function() {
      ajaxGet(
        apiUrl() + "/auth/securityquestions",
        ssq.GetQuestions,
        ssq.dataError,
        null
      );
    }, 100);
  },
  methods: {
    onSubmit: function(event) {
      event.preventDefault();

      //sanity checks here
      if(this.firstQuestionSelection == null || this.firstQuestionSelection < 1 || this.secondQuestionSelection == null || this.secondQuestionSelection < 1) {
        this.ErrorText = "Both security questions must be selected";
        this.showDismissibleAlert = true;
        return;
      }

      if(this.firstAnswer == null || this.firstAnswer == "" || this.secondAnswer == null || this.secondAnswer == "") {
        this.ErrorText = "Both security questions must have answers";
        this.showDismissibleAlert = true;
        return;
      }

      ajaxPost( apiUrl() + "/auth/securityquestions", { firstAnswer: this.firstAnswer, secondAnswer: this.secondAnswer, firstQID: this.firstQuestionSelection, secondQID: this.secondQuestionSelection}, this.setQuestionSuccess, this.dataError, this.token);
    },
    GetQuestions: function(data) {
      for (var a = 0; a < data.Questions.length; a++) {
        this.options.push({
          value: data.Questions[a].ID,
          text: data.Questions[a].Question
        });
      }
    },
    setQuestionSuccess: function() {
        this.$bvToast.toast('Security questions updated!', { autoHideDelay: 5000, appendToast: true});
        this.$router.push("browse/assignments");
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }

      this.loading = false;
    }
  }
};
</script>